module.exports = __webpack_public_path__ + "img/d5709.b04b4ed7.svg";